<app-page-meta pageTitle="finzy - Payment Failed"></app-page-meta>
<app-header></app-header>


<app-payment-failure-template
    [rowOne]="rowOne" 
    [rowTwo]="rowTwo" 
    [templateButtonText]="templateButtonText">
</app-payment-failure-template>

<app-footer></app-footer>